import { gql, useQuery } from "@apollo/client";
import moment from "moment";

import Content from "@/components/common/Content";
import Loader from "@/components/common/Loader/Loader";
import handleServerSideProps from "src/lib/handle-server-side-props";

export async function getServerSideProps({ params, ...context }) {
  const { data, result } = await handleServerSideProps({
    context,
    pageQuery,
    variables: params,
    props: { slug: params.slug },
  });

  if (!data.reviewBySlug) return { notFound: true };
  return result;
}

function AlbumReviewDetail({ slug }) {
  const { data } = useQuery(pageQuery, { variables: { slug } });

  if (!data) return <Loader />;

  const { reviewBySlug: review } = data;
  const releaseDate = review.releaseDate
    ? moment(review.releaseDate).format("MMMM YYYY")
    : "";

  return (
    <Content
      data={{
        ...review,
        title: `${review.artist} - ${review.title}`,
        date: review.reviewDate,
        image: { url: review.cover, width: 640, height: 640 },
      }}
      review
    >
      <div className="row m-0 px-lg-5">
        <article>
          <section
            className="blog_post__block-paragraph"
            dangerouslySetInnerHTML={{ __html: review.review }}
          />
        </article>
      </div>
      <hr />
      <p className="px-lg-5 blog_post__block-paragraph">
        Recommended: {review.recommendedTracks}
      </p>
      <hr />
      <p className="text-center">{`${releaseDate} // ${review.label}`}</p>
    </Content>
  );
}

export default AlbumReviewDetail;

const pageQuery = gql`
  query ReviewBySlug($slug: String!) {
    reviewBySlug(slug: $slug) {
      title
      artist
      review
      releaseDate
      reviewDate
      label
      cover
      recommendedTracks
      authorDj: dj {
        dj
        url
      }
    }
  }
`;
